import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCircleInfo: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCircleInfo} />;
};
